import React from 'react';
import './AdCard.scss';

interface AdCardProps {
  id: string;
  title: string;
  thumbnail: string;
  platform: string;
  status: 'Published' | 'Draft';
  conversionRate?: string;
  views?: string;
  createdDate: string;
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const AdCard: React.FC<AdCardProps> = ({
  id,
  title,
  thumbnail,
  platform,
  status,
  conversionRate,
  views,
  createdDate,
  onView,
  onEdit,
  onDelete,
}) => {
  const getPlatformColor = (platform: string) => {
    switch (platform.toLowerCase()) {
      case 'facebook':
        return '#1877F2';
      case 'instagram':
        return '#E4405F';
      case 'linkedin':
        return '#0A66C2';
      default:
        return '#6C757D';
    }
  };

  const platformColor = getPlatformColor(platform);
  const statusColor = status === 'Published' ? '#4CAF50' : '#9E9E9E';

  return (
    <div className="ad-card">
      {/* Column 1: Thumbnail Image */}
      <div className="ad-thumbnail">
        <img src={thumbnail} alt={title} />
      </div>
      
      {/* Column 2: Content Details */}
      <div className="ad-content">
        <h4 className="ad-title">{title}</h4>
        
        <div className="ad-badges">
          <span className="badge platform-badge" style={{ backgroundColor: platformColor }}>
            <i className="bi bi-{platform.toLowerCase()}"></i> {platform}
          </span>
          <span className="badge status-badge" style={{ backgroundColor: statusColor }}>
            {status}
          </span>
        </div>

        {conversionRate && views && (
          <div className="ad-stats">
            <div className="stat">
              <i className="bi bi-graph-up"></i>
              <span>{conversionRate} conversion</span>
            </div>
            <div className="stat">
              <i className="bi bi-eye"></i>
              <span>{views} views</span>
            </div>
          </div>
        )}

        <div className="ad-footer">
          <span className="created-date">Created {createdDate}</span>
        </div>
      </div>

      {/* Column 3: Action Buttons */}
      <div className="ad-actions">
        <button className="action-btn" onClick={onView} title="View">
          <i className="bi bi-eye"></i>
        </button>
        <button className="action-btn" onClick={onEdit} title="Edit">
          <i className="bi bi-pencil"></i>
        </button>
        <button className="action-btn" onClick={onDelete} title="Delete">
          <i className="bi bi-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default AdCard;
